import React, { Fragment } from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { addTestAutomationClassName } from 'utils/misc'

import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

const styles = theme => ({
  root: {
    zIndex: 10,
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  },
  menuItem: {
    textTransform: 'none',
  },
  icon: {
    fontSize: 28,
    transition: 'all .2s ease',
  },
  iconFlipped: {
    transform: 'scaleY(-1)',
  },
})

class ProfileSelector extends React.PureComponent {
  state = {
    open: false,
    anchorEl: null,
  };

  handleMenu = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  };

  handleMenuClose = () => {
    this.setState({ open: false, anchorEl: null })
  };

  handleProfileClick = () => {
    this.props.actions.redirect('/account/home')
  };

  handleLogoutClick = () => {
    this.props.actions.logoutUser()
  };

  render() {
    const { classes, username } = this.props
    const { anchorEl, open } = this.state

    return (
      <Fragment>
        <div
          id="profile-selector"
          onClick={this.handleMenu}
          className={classNames(
            classes.root,
            addTestAutomationClassName('qa-profileselector-button-menu')
          )}>
          {username}
          <ExpandMore
            className={classNames(classes.icon, open && classes.iconFlipped)}
          />
        </div>
        <Menu
          open={open}
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={this.handleMenuClose}>
          <MenuItem
            onClick={this.handleProfileClick}
            classes={{ root: classes.menuItem }}
            className={addTestAutomationClassName('qa-profileselector-button-profile')}>
            Profile
          </MenuItem>
          <MenuItem
            onClick={this.handleLogoutClick}
            classes={{ root: classes.menuItem }}
            className={addTestAutomationClassName('qa-profileselector-button-logout')}>
            Logout
          </MenuItem>
        </Menu>
      </Fragment>
    )
  }
}

ProfileSelector.propTypes = {
  actions: PropTypes.object,
  classes: PropTypes.object,
  username: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    username: idx(state, _ => _.user.fullName),
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, userActions, routeActions)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const ProfileSelectorComponent = withStyles(styles)(ProfileSelector)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileSelectorComponent)



// WEBPACK FOOTER //
// ./src/components/molecules/ProfileSelector.js